/** "What's new" API calls (practice-wide, not tied to the office selector). */
import { useQuery } from '@tanstack/react-query';
import { WhatsNewResponse } from '@velora/contracts/feedback';
import { z } from 'zod';
import { api } from '../../app/api.js';

export const WHATS_NEW_KEY = ['feedback', 'whats-new'] as const;

export function useWhatsNew(include: 'new' | 'all', enabled: boolean) {
  return useQuery({
    queryKey: [...WHATS_NEW_KEY, include],
    queryFn: ({ signal }) =>
      api.request(`/feedback/whats-new?include=${include}`, { schema: WhatsNewResponse, signal }),
    enabled,
    staleTime: include === 'new' ? 30 * 60_000 : 0,
    retry: false,
  });
}

export function dismissWhatsNew(id: string) {
  return api.request(`/feedback/whats-new/${encodeURIComponent(id)}/dismiss`, {
    method: 'POST',
    schema: z.object({ dismissed: z.boolean() }),
  });
}
